import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const appsApi = createApi({
  reducerPath: 'appsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/apps',
    prepareHeaders: (headers, { getState }) => {
      // Obtener la URL actual
      const url = window.location.href;

      // Crear un objeto URLSearchParams con los parámetros de la URL
      const queryParams = new URLSearchParams(url.split('?')[1]);

      // Convertir los parámetros en un objeto
      const paramsObj = {};
      queryParams.forEach((value, key) => {
          paramsObj[key] = value;
      });

      // If we have a token set in state, let's assume that we should be passing it.
      headers.set('authorization', `Bearer ${paramsObj["token"]}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    validationToken: builder.query({
      query: () => `/validateToken`,
    }),
    getObjects: builder.mutation({
      query(body) {
        return {
          url: `/objects`,
          method: 'POST',
          body,
        };
      },
    }),
    updateObjects: builder.mutation({
      query(body) {
        return {
          url: `/objects`,
          method: 'PUT',
          body,
        };
      },
    }),
    getAccountApp: builder.mutation({
      query(body) {
        return {
          url: `/getConfigClient`,
          method: 'POST',
          body,
        };
      },
    }),
    getMapping: builder.mutation({
      query(body) {
        return {
          url: `/mapping`,
          method: 'POST',
          body,
        };
      },
    }),
    updateMapping: builder.mutation({
      query(body) {
        return {
          url: `/mapping`,
          method: 'PUT',
          body,
        };
      },
    }),
    getGeneralConfigApp: builder.query({
      query: (id) => `/config/${id}`,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useValidationTokenQuery,
  useGetGeneralConfigAppQuery,
  useGetObjectsMutation,
  useUpdateObjectsMutation,
  useGetMappingMutation,
  useUpdateMappingMutation,
  useGetAccountAppMutation,
} = appsApi;
